import { atom } from 'jotai';

import { PAYMENT_METHODS } from '@entities/payment-plan';
import { COUNTRY_SHORT_NAMES } from '@entities/country/model/constants';

import type { DCBState } from '@entities/dcb/model/types';

export const initialState: DCBState = {
  homeData: {
    country: COUNTRY_SHORT_NAMES.AE,
    operators: [],
    msisdnLengthMin: 5,
    msisdnLengthMax: 12,
    fullTCText: '',
    source: '',
  },
  subscribeData: {
    sessionId: 0,
    msisdn: '',
    isRedirect: false,
  },
  otpData: {},
  resendOtpData: {},
  timerActive: true,
  timerCount: 0,
  thankyouData: {},
  countryCode: '+971',
  operator: {
    name: 'Select your operator',
    value: '',
    logo: '',
    isShownMsisdn: 1,
    error: null,
  },
  operators: [],
  operatorSelectedDetails: {},
  phoneNumber: '',
  viewloading: true,
  btnLoading: false,
  error: {},
  isCountryAvailable: true,
  needToResetForm: false,
  dataRetrieved: false,
  dataRetrievedLanguage: 'en',
  source: 'api-web',
  otpError: false,
  fallbackOperator: null,
  reachedThankYou: false,
  isPromoModalShown: false,
  isPromoValid: false,
  promoStep: 1,
  invalidPromocodeError: false,
  offerCode: '',
  userSelectedLanguageManually: false,
  showPhoneOnDesktop: true,
  cacheData: {},
  defaultPaymentMethod: PAYMENT_METHODS.Phone,
  operatorDetectionFinished: false,
  homeUrl: '',
  isV3Route: false,
  dcbHomeReceived: false,
  variationKey: '',
  isInapp: false,
  isAutoSMSRedirect: false,
  uniquePopUpSubmitState: null,
  templateId: '0',
  subscribeRequestData: {},
};

export const dcbAtom = atom<DCBState>(initialState);
